<!--Содержит в себе два v-tab и v-select, с помощью автобуса получает выбранный из choose-region
регион после чего передаёт во второй v-tab нужные данные и открывает item второго v-tab
так же при создании получает список годов и отображает их в v-select, по-умолчанию стоит самый последний год в списке-->
<template>
  <v-container fluid>
    <div style="display:flex; margin: 10pt 8pt 10pt 10pt;">
      <v-tabs v-model="active" slider-color="green" next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
              show-arrows>
        <v-tab class="municipality white--text" ripple>
          {{ nameFirstTab }}
        </v-tab>
        <v-tab-item v-if="yearIsLoading === false">
          <choose-region/>
        </v-tab-item>
        <v-tab-item v-else>
          <vue-simple-spinner style="margin-top: 300px;" line-fg-color="#3f51b5" size="big"/>
        </v-tab-item>
        <v-tab v-if="showRegionTabs === true" class="municipality white--text" ripple>
          {{ nameSecondTab }}
        </v-tab>
        <v-tab-item>
          <main-region-gap :key="regionId" :guest = "guest" :active-year = "activeYear" :region="regionId" :municipality-name="nameSecondTab" :searched="searched"/>
        </v-tab-item>
        <div class="select" style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center;">
          <div>
            <v-select hide-details dark
              v-model="activeYear"
              :items="years"
              label="Нажмите, чтобы выбрать год"
              color="white"
              item-color="black--text"
              @input="setActiveYear($event)"
            ></v-select>
          </div>
          <v-spacer />
          <div v-if="guest">
            <span style="margin-right: 10px; font-size: 0.875rem; font-family: Roboto, sans-serif; color: white; font-weight: 500;
    letter-spacing: 0.0892857143em; text-indent: 0.0892857143em;">
              Вы вошли как ГОСТЬ!
            </span>
            <v-btn dark text @click="login">
              Войти
            </v-btn>
            <v-btn dark text @click="registration">
              Зарегистрироваться
            </v-btn>
          </div>
          <div v-else>
            <v-btn style="pointer-events: none; text-transform: none !important; color: white !important; background-color: #3f51b5" disabled dark text >
              Добро пожаловать!
            </v-btn>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn style="background-color: #3f51b5; text-transform: none !important" dark text
                    v-bind="attrs" v-on="on">
                  {{email}}
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="logout">
                  Выйти
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </v-tabs>
    </div>

  </v-container>
</template>

<script>

import {bus} from "@/main";
import ChooseRegion from "@/components/choose-region";
import axios from "axios";
import MainRegionGap from "@/components/gap";
import Spinner from 'vue-simple-spinner/src/components/Spinner'


export default {
  name: "main-page",
  components: {
    MainRegionGap,
    "vue-simple-spinner": Spinner,
    "choose-region": ChooseRegion,
    "main-region-gap": MainRegionGap,
  },
  props: {
    guest: Boolean,
    email: String
  },
  data() {
    return {
      nameFirstTab: "Муниципальные образования",
      nameSecondTab: "",
      yearIsLoading: false,
      showRegionTabs: false,
      regionId: 0,
      active: 0,
      activeYear: 0,
      years: [],
      searched: ""
    };
  },

  methods: {
    setActiveYear(year) {
      this.searched = ""
      this.activeYear = year
    },
    getYears() {
      this.yearIsLoading = true
      this.activeYear =  new Date().getFullYear() - 2;
      axios
        .post("/eco-passport/get-year")
        .then(response => {
          response.data.forEach(item => {
            this.years.push(item)
            this.yearIsLoading = false
          });
        })
        .catch(e => alert(e.toString()));
    },
    login() {
      this.$router.push({name: "login"})
    },
    logout() {
      axios
        .post("/eco-passport/auth/logout")
        .then(() => {
          this.$router.push({name: "login"})
        })
        .catch(e => alert(e.toString()));
    },
    registration() {
      this.$router.push({name: "registration"})
    }
  },
  created() {
    console.log(this.email)
    this.getYears()
    bus.$on('selectedMunicipality', regionSelected => {
      this.nameSecondTab = regionSelected.name;
      this.regionId = regionSelected.id
      this.active = 1
      this.showRegionTabs = true;
    });
    bus.$on('municipalityIsLoading', loading => {
      this.municipalityIsLoading = loading
    });
    bus.$on('searchedTable', searched => {
      this.searched = searched
    });

  },
};
</script>


<style scoped>

.municipality {
  padding: 12pt 10pt 10pt;
  text-align: center;
  color: white;
  display:block;
  background-color: #3f51b5
}
.select {
  padding-right: 10pt;
  flex: 1;
  display: block;
  background-color: #3f51b5
}
</style>
